module.exports = __webpack_public_path__ + "static/media/FeelBetter.3d34ca7a.jpg";